import { staticFileMap } from '/utils/static-file';
import { productCodeMap } from '@/utils/document/product-code-map';
const path = '/img/products/beautification';
const docConfig = { name: '产品文档', link: productCodeMap.FACE_BUTI };

export const BANNER_DATA = {
  title: '人像美化',
  backgroundImg: `${path}/banner.webp`,
  description:
    '支持PC端、移动端及服务端跨平台兼容的人像美化功能，涵盖美颜、2D/3D美妆、滤镜、精细化面部重塑及五官、体态精准塑形，同时自适应复杂光照环境，实现细腻、真实的美化效果，可调节强度参数，满足个性化需求',
  buttonText: '申请试用',
  buttonLink: '',
  docText: '产品文档',
  mobileExtraButton: { ...docConfig },
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  links: [
    // { name: 'Demo体验', link: '' },
    { ...docConfig },
    // { name: '管理控制台', link: '' },
  ],
};

export const CARDS_EFFECT = [
  {
    title: '智能美颜',
    content:
      '基于人脸关键点等技术，可支持实时的美颜美型等多种美化维度，保留细节特征，轻松实现美白、磨皮、锐化、瘦脸、大眼、隆鼻等医美级美颜效果',
    picUrl: `${path}/3D-icon1.webp`,
  },
  {
    title: '高真实美体',
    content:
      '基于人体关键点技术，对身体体态进行精细化调整，实现长腿、瘦腰、天鹅颈、小头等多个部位的精准塑形，画面背景无扭曲、无抖动，真实度高',
    picUrl: `${path}/3D-icon2.webp`,
  },
  {
    title: '2D/3D美妆',
    content:
      '自适应各类光照条件，动态检测上妆位置，实时完成口红、睫毛、腮红、眉毛、美瞳、眼影等部位的一键式全部上妆或局部上妆',
    picUrl: `${path}/3D-icon3.webp`,
  },
];
export const ADVANTAGES_EFFECT = [
  {
    title: '五官、体态精准塑形',
    content:
      '通过人脸三维重建等算法，实现精细化面部重塑及五官的精准塑形，同时可对身体体态进行精细化调整，背景不变形，达到专业摄影师P图效果',
    picUrl: `${path}/feature-icon1.webp`,
  },
  {
    title: '效果稳定，鲁棒性高',
    content:
      '算法可在强光、弱光、侧脸、大角度、遮挡、近距离和远距离等复杂环境下实现自动效果优化，性能可靠',
    picUrl: `${path}/feature-icon2.webp`,
  },
  {
    title: '适配多种场景',
    content:
      '适用于图片视频等多种场景，检测率高，效果稳定，同时支持多人检测，全面覆盖各类主流手机机型',
    picUrl: `${path}/feature-icon3.webp`,
  },
];

export const SCENARIO = [
  {
    title: '美颜相机',
    content:
      '支持实时美颜、美型、美体和美妆等功能选择，可用于美颜相机、图片美化等场景',
    picUrl: `${path}/scenario1.webp`,
    picHoverUrl: `${path}/scenario1-hover.webp`,
  },
  {
    title: '医疗美容',
    content:
      '支持对人脸五官及面部轮廓的精准定位，可对面部特征进行分析，适配于智能医美等场景的产品落地',
    picUrl: `${path}/scenario2.webp`,
    picHoverUrl: `${path}/scenario2-hover.webp`,
  },
  {
    title: '人脸人体特效',
    content:
      '支持对人脸五官、面部轮廓及身体的精准定位和调整，可更好呈现人脸人体特效的视觉效果',
    picUrl: `${path}/scenario3.webp`,
    picHoverUrl: `${path}/scenario3-hover.webp`,
  },
];

export const DEMO_LIST = {
  title: '功能体验',
  items: [
    {
      title: '美颜',
      subTitle:
        '支持实时美颜的多种美化维度，包括美白、磨皮、锐化、匀肤、祛痘等功能，广泛应用于图片、视频拍摄和直播',
      // videoUrl: staticFileMap['beautification-meiyan'],
      // videoUrlH265: staticFileMap['beautification-meiyan-h265'],
      videoId: '208ac1c472da0d20',
      placeholder: `${path}/meiyan-placeholder.webp`,
    },

    {
      title: '美型',
      subTitle:
        '支持实时美型的多种美化维度，包括瘦脸、大眼、瘦鼻、调整发际线等功能，广泛应用于图片、视频拍摄和直播',
      // videoUrl: staticFileMap['beautification-meixing'],
      videoId: '42574727de82e059',
      placeholder: `${path}/meixing-placeholder.webp`,
    },
    {
      title: '美妆',
      subTitle:
        '支持实时美妆的多种美化维度，包括口红、眉毛、腮红、眼妆、美瞳等效果，广泛应用于图片、视频拍摄和直播',
      // videoUrl: staticFileMap['beautification-meizhuang'],
      videoId: '430ee6d6ae49b207',
      placeholder: `${path}/meizhuang-placeholder.webp`,
    },
  ],
};

export const BRAND = {
  title: '客户案例',
  items: ['快手', '一甜'],
};
